import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'initials'
})
export class InitialsPipe implements PipeTransform {
    transform(name: string): string {
        if (!name) return '';
        const parts = name.split(' ');
        let initials = pieces(parts[0]);
        if (parts.length > 1) {
            initials += pieces(parts[parts.length - 1]);
        }
        return initials.toUpperCase();
    }
}

function pieces(part: string): string {
    if (!part) return '';
    return part[0];
}
